<div class="card-head">
  <h1>{{ 'auth.YouAlmostSet' | translate }}</h1>
</div>


<div *ngIf='loading' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div *ngIf="!loading">
  <div *ngIf="isActivated">
    <h4 class="text-center">{{ 'auth.Your account has been activated successfully' | translate }}</h4>
  </div>

  <div class="mb-5" *ngIf="!isActivated">
    <h4 class="text-center text-danger">{{ 'auth.invalidActivation' | translate }}</h4>
  </div>
</div>

<div class="card-action">
  <a [routerLink]="['/login']">{{ 'auth.Login' | translate }}</a>
</div>
